// chakra imports
import { Box, Flex, Stack } from '@chakra-ui/react';
//   Custom components
import Brand from './Brand';
import Links from './Links';
import SidebarCard from './SidebarCard';
import React from 'react';
import PropTypes from 'prop-types';

// FUNCTIONS

function SidebarContent(props) {
  const { routes, isCompact = false, isCollapsed = false, onLinkClick } = props;
  // SIDEBAR
  return (
    <Flex
      direction="column"
      height="100%"
      pt={isCompact ? '24px' : '32px'}
      px={isCompact ? '12px' : '20px'}
      borderRadius="30px"
      align={isCollapsed ? 'center' : 'stretch'}
    >
      <Box ps={isCollapsed ? 0 : '10px'} w="100%">
        <Brand isCompact={isCompact} isCollapsed={isCollapsed} />
      </Box>
      <Stack direction="column" mb="auto" mt={isCompact ? '4px' : '12px'} w="100%">
        <Box
          ps={isCollapsed ? 0 : '10px'}
          pe={{ md: isCompact ? '8px' : '16px', '2xl': '1px' }}
          w="100%"
        >
          <Links
            routes={routes}
            isCompact={isCompact}
            isCollapsed={isCollapsed}
            onLinkClick={onLinkClick}
          />
        </Box>
      </Stack>

      <Box
        mt="40px"
        mb="24px"
        borderRadius="30px"
        display={isCollapsed ? 'none' : 'block'}
      >
        <SidebarCard />
      </Box>
    </Flex>
  );
}

SidebarContent.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  isCompact: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  onLinkClick: PropTypes.func,
};

export default SidebarContent;
